"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualPaymentPanelWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var PanelDashed_1 = require("../../../components/PanelDashed");
var services_1 = require("@falcon/services");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../../commonFunctions");
var journey_model_1 = require("@athena-portal/journey-model");
var core_1 = require("@athena-portal/core");
var CheckboxWidget_1 = require("../../CheckboxWidget");
var reactstrap_1 = require("reactstrap");
var journey_services_1 = require("@athena-portal/journey-services");
var AnnualPaymentPanelWidget = /** @class */ (function (_super) {
    __extends(AnnualPaymentPanelWidget, _super);
    function AnnualPaymentPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.termsAndConditionsText = "I confirm the cover I’ve chosen meets my needs and all the information I’ve given is correct. I understand that if any details I’ve given are false or inaccurate, or if we identify fraud, any claims I make could be rejected or not paid, and my insurance could be cancelled.";
        _this.renderPayButton = function (renderCancelChangesButton, reuseCard, paymentAmount, cardExpired) {
            var onClickHandler = reuseCard
                ? function (event) { return _this.handleOnClick(event, cardExpired); }
                : _this.navigateToDifferentCard;
            var buttonId = reuseCard ? "card-1" : "pay-with-new-card";
            var payButtonClass = "btn btn-primary";
            payButtonClass += renderCancelChangesButton ? " btn-next" : " btn-make-payment m-auto";
            var payButtonLabel = cardExpired ? "Update payment card" : "Pay ".concat((0, commonFunctions_1.getAmountToDisplay)(paymentAmount));
            return (0, jsx_runtime_1.jsxs)("button", { className: payButtonClass, onClick: onClickHandler, id: buttonId, children: ["".concat(payButtonLabel), (0, jsx_runtime_1.jsx)("span", { className: "payment-lock-image-raw" })] });
        };
        _this.renderTermsAndPayment = function (reuseCard, paymentAmount, cardExpired) {
            return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [_this.isShowTerms && _this.renderTermsAndConditions(), _this.isShowTerms && _this.renderTermsPopup(), (0, jsx_runtime_1.jsx)("div", { className: "card-buttons", children: _this.renderPaymentButtons(reuseCard, paymentAmount, cardExpired) })] });
        };
        _this.renderPaymentButtons = function (reuseCard, paymentAmount, cardExpired) {
            // if setting is present, will render Cancel changes button in widget and change button classes to align them
            // change event is triggered on click, so navigation is done through onChange in widget commands on according page
            var renderCancelChangesButton = _this.getSetting("renderCancelChangesButton", false);
            return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [renderCancelChangesButton && _this.renderCancelChangesButton(), _this.renderPayButton(renderCancelChangesButton, reuseCard, paymentAmount, cardExpired)] });
        };
        _this.handleOnCheckboxChange = function (event) {
            journey_services_1.ObjectManipulator.setField("agreeToTermsAndConditions", _this.props.interaction, event.target.checked);
            _this.setState({ agreeToTermsAndConditionsValidationError: !event.target.checked });
        };
        _this.navigateToDifferentCard = function () {
            if (_this.isShowTerms && !_this.props.interaction.agreeToTermsAndConditions) {
                _this.openTermsPopup();
            }
            else {
                _this.navigateToNewPaymentCardPage();
            }
        };
        _this.openTermsPopup = function () {
            _this.setState({ showTermsPopup: true });
        };
        _this.closeTermsPopup = function () {
            _this.setState({ showTermsPopup: false });
        };
        _this.navigateToNewPaymentCardPage = function () {
            var newCardPaymentPage = _this.getSetting("newCardPaymentPage");
            if (newCardPaymentPage) {
                _this.props.engine.navigate(newCardPaymentPage, true);
            }
        };
        _this.renderCancelChangesButton = function () {
            return ((0, jsx_runtime_1.jsx)("button", { className: "btn btn-white btn-back", onClick: _this.triggerChangeEventOnCancelChanges, children: "Cancel changes" }));
        };
        _this.triggerChangeEventOnCancelChanges = function () {
            var renderCancelChangesButton = _this.getSetting("renderCancelChangesButton", false);
            if (renderCancelChangesButton) {
                _this.executeEvent('change');
            }
        };
        _this.renderCardInformation = function () {
            if (_this.state.paymentCard) {
                return ((0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-center mt-3", children: (0, jsx_runtime_1.jsxs)("div", { className: "card-details-wrapper", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "pr-2", children: _this.renderCardImage(_this.state.paymentCard) }), "\u00A0"] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { children: _this.renderCardTypeName(_this.state.paymentCard) }), "\u00A0", (0, jsx_runtime_1.jsxs)("span", { children: ["ending in ", (0, jsx_runtime_1.jsx)("b", { children: _this.state.paymentCard.cardNumberObfuscated.split('******')[1] })] })] }), (0, jsx_runtime_1.jsx)("div", { className: "card-details-wrapper", children: _this.renderExpiryDate(_this.state.paymentCard) })] })] }) }));
            }
            else {
                return (0, jsx_runtime_1.jsx)(React.Fragment, {});
            }
        };
        _this.renderExpiryDate = function (card) {
            var monthFormatter = new Intl.DateTimeFormat('en', {
                month: 'short'
            });
            var cardExpired = (0, commonFunctions_1.isCardExpired)(card);
            var textStyle = cardExpired ? "text-danger" : "";
            return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: textStyle, children: "Expiry date: \u00A0 " }), (0, jsx_runtime_1.jsx)("span", { className: textStyle, children: monthFormatter.format(new Date(card.expiryYear, card.expiryMonth - 1, 1)) + " `" + card.expiryYear })] });
        };
        _this.renderCardImage = function (card) {
            if (card.cardType.includes("VISA")) {
                return (0, jsx_runtime_1.jsx)("img", { className: "payment-icon", alt: "Visa icon", src: "/img/visa-icon.svg" });
            }
            if (card.cardType.includes("MASTERCARD")) {
                return (0, jsx_runtime_1.jsx)("img", { className: "payment-icon", alt: "Mastercard icon", src: "/img/mastercard-icon.svg" });
            }
            return (0, jsx_runtime_1.jsx)(React.Fragment, {});
        };
        _this.renderCardTypeName = function (card) {
            if (card.cardType.includes("VISA")) {
                return "Visa";
            }
            if (card.cardType.includes("MASTERCARD")) {
                return "Mastercard";
            }
            return "";
        };
        _this.setState({
            paymentCard: new services_1.PaymentCard(),
            showTermsPopup: false,
            agreeToTermsAndConditionsValidationError: false
        });
        var process = _this.props.interaction.process;
        _this.isShowTerms = !(0, commonFunctions_1.isRenewal)(process) && _this.getSetting("isShowTerms", true);
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        return _this;
    }
    AnnualPaymentPanelWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getMainPaymentCard(this.props.interaction.agreementNumber).subscribe(function (paymentCard) {
            _this.setState({
                paymentCard: paymentCard
            });
        });
    };
    AnnualPaymentPanelWidget.prototype.render = function () {
        var _a;
        var additionalPremium = this.props.interaction.factors.additionalPremium;
        var premium = this.props.interaction.factors.premium;
        var deposit = services_1.productHelper.isHomeOrWolfMotor(this.props.interaction) ?
            this.props.interaction.paymentDetails.instalmentPlan.deposit : 0;
        var showRenewalAnnualPremium = this.getSetting("showRenewalAnnualPremium", false);
        if (((_a = this.state) === null || _a === void 0 ? void 0 : _a.paymentCard) === undefined) {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
        else {
            return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (additionalPremium !== 0 && this.renderPaymentContent()) || (premium !== 0 && this.renderPaymentContent()) || (deposit !== 0 && this.renderPaymentContent()) || (showRenewalAnnualPremium && this.renderPaymentContent()) }));
        }
    };
    AnnualPaymentPanelWidget.prototype.renderPaymentContent = function () {
        var upfrontInterest = this.getSetting("payUpfrontInterest", false);
        var debtCombined = this.props.interaction.factors.debtAmount > 0 &&
            this.props.interaction.factors.mtaAndDebtCombinedAdditionalAmount > 0;
        return ((0, jsx_runtime_1.jsx)(PanelDashed_1.PanelDashed, { className: "bg-white text-center pay-by-card-panel", children: this.renderPaymentOptionsForCustomerPortal((0, commonFunctions_1.getInteractionPaymentAmount)(this.props.interaction, upfrontInterest, debtCombined)) }));
    };
    AnnualPaymentPanelWidget.prototype.renderPaymentOptionsForCustomerPortal = function (paymentAmount) {
        var _a;
        var reuseCard = ((_a = this.state.paymentCard) === null || _a === void 0 ? void 0 : _a.reuseCard) || false;
        var cardExpired;
        if (this.state.paymentCard) {
            cardExpired = (0, commonFunctions_1.isCardExpired)(this.state.paymentCard);
        }
        return reuseCard ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "panel-dashed-contents card-information", children: this.renderCardInformation() }), !cardExpired && (0, jsx_runtime_1.jsx)("div", { className: "pb-2 or-divider", children: " OR " }), !cardExpired && (0, jsx_runtime_1.jsx)("div", { className: "simple-link no-outline use-different-cart-link", id: "changeCard", "aria-label": "Use a different card to pay", onClick: this.navigateToDifferentCard, onKeyDown: this.navigateToDifferentCard, "aria-hidden": true, children: "Use a different card" }), !!cardExpired &&
                    (0, jsx_runtime_1.jsx)("div", { className: "mt-3", children: (0, jsx_runtime_1.jsxs)("p", { className: "text-danger", children: [(0, jsx_runtime_1.jsx)("img", { className: "d-inline", src: "/img/card-expiry-warn-icon.svg", alt: "Card expired" }), "Your card has expired ", (0, jsx_runtime_1.jsx)("br", {}), "Please update your payment card"] }) }), this.renderTermsAndPayment(reuseCard, paymentAmount, cardExpired)] })) : ((0, jsx_runtime_1.jsx)("div", { children: this.renderTermsAndPayment(reuseCard, paymentAmount, cardExpired) }));
    };
    AnnualPaymentPanelWidget.prototype.renderTermsAndConditions = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h2", { className: "terms-conditions-title", children: "Terms and Conditions" }), (0, jsx_runtime_1.jsx)(CheckboxWidget_1.default, { callback: this.handleOnCheckboxChange, defaultValue: this.props.interaction.agreeToTermsAndConditions, label: this.termsAndConditionsText }), this.state.agreeToTermsAndConditionsValidationError &&
                    (0, jsx_runtime_1.jsxs)("div", { className: "invalid-feedback d-block", children: ["To proceed you must agree to the ", services_1.resourcesHelper.THEME, " terms and conditions and privacy policy"] })] }));
    };
    AnnualPaymentPanelWidget.prototype.renderTermsPopup = function () {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.closeTermsPopup });
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "info-modal", isOpen: this.state.showTermsPopup, style: { maxWidth: '816px' }, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { close: closeBtn, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("img", { className: "info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "Info icon" }), (0, jsx_runtime_1.jsx)("span", { className: "text-blue-2 fs-20 font-weight-medium", children: "Before changing your payment card.." })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "pt-0", children: (0, jsx_runtime_1.jsx)("p", { className: "font-weight-extra-light", children: "I confirm the cover I've chosen meets my needs and all the information I've given is correct. I understand that if any details I've given are false or inaccurate, or if we identify fraud, any claim I make could be rejected or not paid, and my insurance could be cancelled." }) }), (0, jsx_runtime_1.jsx)("div", { className: "empty-column" }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalFooter, { className: "d-block", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-white", onClick: this.closeTermsPopup, children: "Cancel" }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary", onClick: this.navigateToNewPaymentCardPage, children: "Confirm & continue" })] })] }));
    };
    AnnualPaymentPanelWidget.prototype.handleOnClick = function (event, cardExpired) {
        if (cardExpired) {
            sessionStorage.setItem("directRedirectAfterCardSave", window.location.pathname);
            window.location.assign("/dashboard/account/changeCard/".concat(this.props.interaction.agreementNumber));
        }
        else if (!this.props.interaction.agreeToTermsAndConditions && this.isShowTerms) {
            this.setState({ agreeToTermsAndConditionsValidationError: true });
        }
        else {
            this.props.engine.callInteractionSetState(__assign({}, this.props.engine.getInteraction()));
            this.executeEvent('click');
            event.preventDefault();
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualPaymentPanelWidget.prototype, "customerPortalService", void 0);
    AnnualPaymentPanelWidget = __decorate([
        components_1.authorize,
        (0, journey_model_1.settings)([
            { name: "payUpfrontInterest", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualPaymentPanelWidget);
    return AnnualPaymentPanelWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualPaymentPanelWidget = AnnualPaymentPanelWidget;
//# sourceMappingURL=AnnualPaymentPanelWidget.js.map